import { render, staticRenderFns } from "./PayoutsConfirmationModal.vue?vue&type=template&id=2dc5d6fc&"
import script from "./PayoutsConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./PayoutsConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports